

import c1 from '@/assets/imgs/chips/c01.png';
import c10 from '@/assets/imgs/chips/c02.png';
import c100 from '@/assets/imgs/chips/c03.png';
import c1k from '@/assets/imgs/chips/c04.png';
import c10k from '@/assets/imgs/chips/c05.png';

interface Coin {
    img: string;
    name: string;
    value: number;
    inUse?: boolean;
    amount?: number; // 动态值，表示此筹码代表的金额（value * minBetAmount)
    amountStr?: string;
    sTip?: string; // 提示用户余额不足等
}

type CoinList = Coin[];

// ↓ 筹码列表
export const aCoinList:CoinList = [{
    img: c1,
    name: '1',
    value: 1,
    inUse: true, // 按新需要默认启用此项
}, {
    img: c10,
    name: '10',
    value: 10,
}, {
    img: c100,
    name: '100',
    value: 100,
}, {
    img: c1k,
    name: '1k',
    value: 1_000,
}, {
    img: c10k,
    name: '10k',
    value: 10_000,
}, 
// ↓ 在新需要中被废弃 ↓ 
// {
//     img: c100k,
//     name: '100k',
//     value: 100_000,
// }, {
//     img: c1m,
//     name: '1m',
//     value: 1_000_000,
// },
];

// ↓红色数字
export const aRedNumber = [
    1, 3, 5, 7, 9,
    12, 14, 16, 18,
    19, 21, 23, 25, 27,
    30, 32, 34, 36,
];

interface ButtonIF {
    class: string;
    gridArea: string;
    placed?: number; // 已经押注的数量
    hidden?: boolean;
    value?: number;
    title?: string;
    areaName?: string; // 诸如：1-12 
    classOnChild?: string;
    mark?: string;
    color?: string,
    represent?: string,
    refer2?: number[], 
    sValueSign?: string, 
};

// 所有 12 列的数字
const aColumn = [
    [3, 2, 1], // 第 0 列
    [6, 5, 4], // 第 1 列
    [9, 8, 7], // ...
    [12, 11, 10],
    [15, 14, 13],
    [18, 17, 16],
    [21, 20, 19],
    [24, 23, 22],
    [27, 26, 25],
    [30, 29, 28],
    [33, 32, 31],
    [36, 35, 34],
];

const oneTo36 = [...Array(36).keys()].map(cur => {
    return cur + 1;
});

// ↓ 可见选项
const aButtonInShow: ButtonIF[] = [{
    value: 0,
    class: 'slot-0',
    gridArea: '',
}, {
    value: 3,
    class: 'false   item00',
    gridArea: '1 / 2',
}, {
    value: 6,
    class: 'false  item01',
    gridArea: '1 / 3',
}, {
    value: 9,
    class: 'false  item02',
    gridArea: '1 / 4',
}, {
    value: 12,
    class: 'false  item03',
    gridArea: '1 / 5',
}, {
    value: 15,
    class: 'false  item04',
    gridArea: '1 / 6',
}, {
    value: 18,
    class: 'false  item05',
    gridArea: '1 / 7',
}, {
    value: 21,
    class: 'false  item06',
    gridArea: '1 / 8',
}, {
    value: 24,
    class: 'false  item07',
    gridArea: '1 / 9',
}, {
    value: 27,
    class: 'false  item08',
    gridArea: '1 / 10',
}, {
    value: 30,
    class: 'false  item09',
    gridArea: '1 / 11',
}, {
    value: 33,
    class: 'false  item010',
    gridArea: '1 / 12',
}, {
    value: 36,
    class: 'false  item011',
    gridArea: '1 / 13',
}, {
    value: 2,
    class: 'false  item10',
    gridArea: '2 / 2',
}, {
    value: 5,
    class: 'false  item11',
    gridArea: '2 / 3',
}, {
    value: 8,
    class: 'false  item12',
    gridArea: '2 / 4',
}, {
    value: 11,
    class: 'false  item13',
    gridArea: '2 / 5',
}, {
    value: 14,
    class: 'false  item14',
    gridArea: '2 / 6',
}, {
    value: 17,
    class: 'false  item15',
    gridArea: '2 / 7',
}, {
    value: 20,
    class: 'false  item16',
    gridArea: '2 / 8',
}, {
    value: 23,
    class: 'false  item17',
    gridArea: '2 / 9',
}, {
    value: 26,
    class: 'false  item18',
    gridArea: '2 / 10',
    represent: 'Jeu Zero',
}, {
    value: 29,
    class: 'false  item19',
    gridArea: '2 / 11',
}, {
    value: 32,
    class: 'false  item110',
    gridArea: '2 / 12',
}, {
    value: 35,
    class: 'false  item111',
    gridArea: '2 / 13',
}, {
    value: 1,
    class: 'false  item20',
    gridArea: '3 / 2',
    represent: 'Orphelins',
}, {
    value: 4,
    class: 'false  item21',
    gridArea: '3 / 3',
}, {
    value: 7,
    class: 'false  item22',
    gridArea: '3 / 4',
}, {
    value: 10,
    class: 'false  item23',
    gridArea: '3 / 5',
}, {
    value: 13,
    class: 'false  item24',
    gridArea: '3 / 6',
}, {
    value: 16,
    class: 'false  item25',
    gridArea: '3 / 7',
}, {
    value: 19,
    class: 'false  item26',
    gridArea: '3 / 8',
}, {
    value: 22,
    class: 'false  item27',
    gridArea: '3 / 9',
}, {
    value: 25,
    class: 'false  item28',
    gridArea: '3 / 10',
}, {
    value: 28,
    class: 'false  item29',
    gridArea: '3 / 11',
}, {
    value: 31,
    class: 'false  item210',
    gridArea: '3 / 12',
}, {
    value: 34,
    class: 'false  item211',
    gridArea: '3 / 13',
}, {
    title: '2:1',
    areaName: '2-1-3',
    class: 'false',
    classOnChild: 'board__bet-value-text',
    gridArea: '1 / 14',
    refer2: aColumn.map(cur => cur[0]),
}, {
    title: '2:1',
    areaName: '2-1-2',
    class: 'false',
    classOnChild: 'board__bet-value-text',
    gridArea: '2 / 14',
    refer2: aColumn.map(cur => cur[1]),
}, {
    title: '2:1',
    areaName: '2-1-1',
    class: 'false',
    classOnChild: 'board__bet-value-text',
    gridArea: '3 / 14',
    refer2: aColumn.map(cur => cur[2]),
},
// ---- ↑ 上方内容 ---------------------------------------------
// ---- ↓ 下方内容 ---------------------------------------------
{
    title: '1-12',
    areaName: '1-12',
    class: 'false board__bet-value-text',
    gridArea: '4 / 2 / auto / span 4',
    refer2: oneTo36.slice(0, 12),
}, {
    title: '13-24',
    areaName: '13-24',
    class: 'false board__bet-value-text',
    gridArea: '4 / span 4',
    refer2: oneTo36.slice(12, 24),
}, {
    title: '25-36',
    areaName: '25-36',
    class: 'false board__bet-value-text',
    gridArea: '4 / span 4',
    refer2: oneTo36.slice(24),
},
// ---------------------------------------------------------------
{
    title: '1-18',
    areaName: '1to18', // ❇️ areaName 将被转换为 sValueSign，后者将与对象返回值做对比判断，不能随意修改
    class: 'false board__bet-value-text',
    gridArea: '5 / 2 / auto / span 2',
    refer2: oneTo36.slice(0, 18),
}, {
    title: 'even',
    areaName: 'even',
    class: 'false board__bet-value-text',
    gridArea: '5 / span 2',
    refer2: oneTo36.filter(cur => cur % 2 === 0),
}, {
    title: 'Red',
    areaName: 'red',
    class: 'false', // 红色
    color: 'red',
    gridArea: '5 / span 2',
    refer2: aRedNumber,
}, {
    title: 'Black',
    areaName: 'black',
    class: 'false', // 黑色
    color: 'black',
    gridArea: '5 / span 2',
    refer2: oneTo36.filter(cur => !aRedNumber.includes(cur)),
}, {
    title: 'odd',
    areaName: 'odd',
    class: 'false board__bet-value-text',
    gridArea: '5 / span 2',
    refer2: oneTo36.filter(cur => cur % 2 === 1),
}, {
    title: '19-36',
    areaName: '19to36',
    class: 'false board__bet-value-text',
    gridArea: '5 / span 2',
    refer2: oneTo36.slice(18),
},].map((cur: ButtonIF) => {
    cur.color ||= (() => {
        if (cur.title) return 'gray';
        if (aRedNumber.includes(cur.value)) return 'red';
        if (cur.value > 0) return 'black';
        return '';
    })();
    return cur;
});

// ↑可见选择
// ↓不可见选择

const aButtonHidden: ButtonIF[] = [{
    mark: '■■■ On 1 column ■■■',
    class: 'board__bets__hiden-t',
    gridArea: '1 / 2',
    refer2: aColumn[0],
}, {
    class: 'board__bets__hiden-t',
    gridArea: '1 / 3',
    refer2: aColumn[1],
}, {
    class: 'board__bets__hiden-t',
    gridArea: '1 / 4',
    refer2: aColumn[2],
}, {
    class: 'board__bets__hiden-t',
    gridArea: '1 / 5',
    refer2: aColumn[3],
}, {
    class: 'board__bets__hiden-t',
    gridArea: '1 / 6',
    refer2: aColumn[4],
}, {
    class: 'board__bets__hiden-t',
    gridArea: '1 / 7',
    refer2: aColumn[5],
}, {
    class: 'board__bets__hiden-t',
    gridArea: '1 / 8',
    refer2: aColumn[6],
}, {
    class: 'board__bets__hiden-t',
    gridArea: '1 / 9',
    refer2: aColumn[7],
}, {
    class: 'board__bets__hiden-t',
    gridArea: '1 / 10',
    refer2: aColumn[8],
}, {
    class: 'board__bets__hiden-t',
    gridArea: '1 / 11',
    refer2: aColumn[9],
}, {
    class: 'board__bets__hiden-t',
    gridArea: '1 / 12',
    refer2: aColumn[10],
}, {
    class: 'board__bets__hiden-t',
    gridArea: '1 / 13',
    refer2: aColumn[11],
},
// -------- ↑ 第 1 行，压住 1 列 ----------------------------------------
// -------- ↓ 第 1 行，压住 2 列 ----------------------------------------
{
    mark: '■■■ On 2 column ■■■',
    class: 'board__bets__hiden-t-d',
    gridArea: '1 / 1 / auto / span 2',
    refer2: [0, ...aColumn[0]],
}, {
    class: 'board__bets__hiden-t-d',
    gridArea: '1 / 2 / auto / span 2',
    refer2: [...aColumn[0], ...aColumn[1]],
}, {
    class: 'board__bets__hiden-t-d',
    gridArea: '1 / 3 / auto / span 2',
    refer2: [...aColumn[1], ...aColumn[2]],
}, {
    class: 'board__bets__hiden-t-d',
    gridArea: '1 / 4 / auto / span 2',
    refer2: [...aColumn[2], ...aColumn[3]],
}, {
    class: 'board__bets__hiden-t-d',
    gridArea: '1 / 5 / auto / span 2',
    refer2: [...aColumn[3], ...aColumn[4]],
}, {
    class: 'board__bets__hiden-t-d',
    gridArea: '1 / 6 / auto / span 2',
    refer2: [...aColumn[4], ...aColumn[5]],
}, {
    class: 'board__bets__hiden-t-d',
    gridArea: '1 / 7 / auto / span 2',
    refer2: [...aColumn[5], ...aColumn[6]],
}, {
    class: 'board__bets__hiden-t-d',
    gridArea: '1 / 8 / auto / span 2',
    refer2: [...aColumn[6], ...aColumn[7]],
}, {
    class: 'board__bets__hiden-t-d',
    gridArea: '1 / 9 / auto / span 2',
    refer2: [...aColumn[7], ...aColumn[8]],
}, {
    class: 'board__bets__hiden-t-d',
    gridArea: '1 / 10 / auto / span 2',
    refer2: [...aColumn[8], ...aColumn[9]],
}, {
    class: 'board__bets__hiden-t-d',
    gridArea: '1 / 11 / auto / span 2',
    refer2: [...aColumn[9], ...aColumn[10]],
}, {
    class: 'board__bets__hiden-t-d',
    gridArea: '1 / 12 / auto / span 2',
    refer2: [...aColumn[10], ...aColumn[11]],
},

// -------- ↓ 横向：第 2 行 ----------------------------------------
{
    mark: '■■■ On up & down ■■■',
    class: 'board__bets__hiden-h itemH00',
    gridArea: '1 / 2 / span 2',
    refer2: aColumn[0].slice(0, 2),
}, {
    class: 'board__bets__hiden-h itemH01',
    gridArea: '1 / 3 / span 2',
    refer2: aColumn[1].slice(0, 2),
}, {
    class: 'board__bets__hiden-h itemH02',
    gridArea: '1 / 4 / span 2',
    refer2: aColumn[2].slice(0, 2),
}, {
    class: 'board__bets__hiden-h itemH03',
    gridArea: '1 / 5 / span 2',
    refer2: aColumn[3].slice(0, 2),
}, {
    class: 'board__bets__hiden-h itemH04',
    gridArea: '1 / 6 / span 2',
    refer2: aColumn[4].slice(0, 2),
}, {
    class: 'board__bets__hiden-h itemH05',
    gridArea: '1 / 7 / span 2',
    refer2: aColumn[5].slice(0, 2),
}, {
    class: 'board__bets__hiden-h itemH06',
    gridArea: '1 / 8 / span 2',
    refer2: aColumn[6].slice(0, 2),
}, {
    class: 'board__bets__hiden-h itemH07',
    gridArea: '1 / 9 / span 2',
    refer2: aColumn[7].slice(0, 2),
    represent: 'Tiers',
}, {
    class: 'board__bets__hiden-h itemH08',
    gridArea: '1 / 10 / span 2',
    refer2: aColumn[8].slice(0, 2),
}, {
    class: 'board__bets__hiden-h itemH09',
    gridArea: '1 / 11 / span 2',
    refer2: aColumn[9].slice(0, 2),
}, {
    class: 'board__bets__hiden-h itemH010',
    gridArea: '1 / 12 / span 2',
    refer2: aColumn[10].slice(0, 2),
}, {
    class: 'board__bets__hiden-h itemH011',
    gridArea: '1 / 13 / span 2',
    refer2: aColumn[11].slice(0, 2),
}, {
    class: 'board__bets__hiden-h itemH10',
    gridArea: '2 / 2 / span 2',
    refer2: aColumn[0].slice(1),
}, {
    class: 'board__bets__hiden-h itemH11',
    gridArea: '2 / 3 / span 2',
    refer2: aColumn[1].slice(1),
}, {
    class: 'board__bets__hiden-h itemH12',
    gridArea: '2 / 4 / span 2',
    refer2: aColumn[2].slice(1),
}, {
    class: 'board__bets__hiden-h itemH13',
    gridArea: '2 / 5 / span 2',
    refer2: aColumn[3].slice(1),
    represent: 'Tiers',
}, {
    class: 'board__bets__hiden-h itemH14',
    gridArea: '2 / 6 / span 2',
    refer2: aColumn[4].slice(1),
}, {
    class: 'board__bets__hiden-h itemH15',
    gridArea: '2 / 7 / span 2',
    refer2: aColumn[5].slice(1),
}, {
    class: 'board__bets__hiden-h itemH16',
    gridArea: '2 / 8 / span 2',
    refer2: aColumn[6].slice(1),
}, {
    class: 'board__bets__hiden-h itemH17',
    gridArea: '2 / 9 / span 2',
    refer2: aColumn[7].slice(1),
}, {
    class: 'board__bets__hiden-h itemH18',
    gridArea: '2 / 10 / span 2',
    refer2: aColumn[8].slice(1),
}, {
    class: 'board__bets__hiden-h itemH19',
    gridArea: '2 / 11 / span 2',
    refer2: aColumn[9].slice(1),
}, {
    class: 'board__bets__hiden-h itemH110',
    gridArea: '2 / 12 / span 2',
    refer2: aColumn[10].slice(1),
}, {
    class: 'board__bets__hiden-h itemH111',
    gridArea: '2 / 13 / span 2',
    refer2: aColumn[11].slice(1),
},
// -------- ↑ 横向部分 ---------------------------------------
// -------- ↓ 竖向部分 ---------------------------------------
{
    mark: '■■■ On left & right ■■■',
    class: 'board__bets__hiden-v itemV00',
    gridArea: '1 / 2 / auto / span 2',
    refer2: [3, 6],
}, {
    class: 'board__bets__hiden-v itemV01',
    gridArea: '1 / 3 / auto / span 2',
    refer2: [6, 9],
    represent: 'Orphelins',
}, {
    class: 'board__bets__hiden-v itemV02',
    gridArea: '1 / 4 / auto / span 2',
    refer2: [9, 12],
}, {
    class: 'board__bets__hiden-v itemV03',
    gridArea: '1 / 5 / auto / span 2',
    refer2: [12, 15],
    represent: 'Voisins,Jeu Zero',
}, {
    class: 'board__bets__hiden-v itemV04',
    gridArea: '1 / 6 / auto / span 2',
    refer2: [15, 18],
}, {
    class: 'board__bets__hiden-v itemV05',
    gridArea: '1 / 7 / auto / span 2',
    refer2: [18, 21],
    represent: 'Voisins',
}, {
    class: 'board__bets__hiden-v itemV06',
    gridArea: '1 / 8 / auto / span 2',
    refer2: [21, 24],
}, {
    class: 'board__bets__hiden-v itemV07',
    gridArea: '1 / 9 / auto / span 2',
    refer2: [24, 27],
}, {
    class: 'board__bets__hiden-v itemV08',
    gridArea: '1 / 10 / auto / span 2',
    refer2: [27, 30],
    represent: 'Tiers',
}, {
    class: 'board__bets__hiden-v itemV09',
    gridArea: '1 / 11 / auto / span 2',
    refer2: [30, 33],
}, {
    class: 'board__bets__hiden-v itemV010',
    gridArea: '1 / 12 / auto / span 2',
    refer2: [33, 36],
    represent: 'Tiers',
},
// ===================================
{
    class: 'board__bets__hiden-v itemV10',
    gridArea: '2 / 2 / auto / span 2',
    refer2: [2, 5],
}, {
    class: 'board__bets__hiden-v itemV11',
    gridArea: '2 / 3 / auto / span 2',
    refer2: [5, 8],
    represent: 'Tiers',
}, {
    class: 'board__bets__hiden-v itemV12',
    gridArea: '2 / 4 / auto / span 2',
    refer2: [8, 11],
}, {
    class: 'board__bets__hiden-v itemV13',
    gridArea: '2 / 5 / auto / span 2',
    refer2: [11, 14],
}, {
    class: 'board__bets__hiden-v itemV14',
    gridArea: '2 / 6 / auto / span 2',
    refer2: [14, 17],
    represent: 'Orphelins',
}, {
    class: 'board__bets__hiden-v itemV15',
    gridArea: '2 / 7 / auto / span 2',
    refer2: [17, 20],
    represent: 'Orphelins',
}, {
    class: 'board__bets__hiden-v itemV16',
    gridArea: '2 / 8 / auto / span 2',
    refer2: [20, 23],
}, {
    class: 'board__bets__hiden-v itemV17',
    gridArea: '2 / 9 / auto / span 2',
    refer2: [23, 26],
}, {
    class: 'board__bets__hiden-v itemV18',
    gridArea: '2 / 10 / auto / span 2',
    refer2: [26, 29],
}, {
    class: 'board__bets__hiden-v itemV19',
    gridArea: '2 / 11 / auto / span 2',
    refer2: [29, 32],
}, {
    class: 'board__bets__hiden-v itemV110',
    gridArea: '2 / 12 / auto / span 2',
    refer2: [32, 35],
    represent: 'Voisins,Jeu Zero',
},
// ==============================================
{
    class: 'board__bets__hiden-v itemV20',
    gridArea: '3 / 2 / auto / span 2',
    refer2: [1, 4],
}, {
    class: 'board__bets__hiden-v itemV21',
    gridArea: '3 / 3 / auto / span 2',
    refer2: [4, 7],
    represent: 'Voisins',
}, {
    class: 'board__bets__hiden-v itemV22',
    gridArea: '3 / 4 / auto / span 2',
    refer2: [7, 10],
}, {
    class: 'board__bets__hiden-v itemV23',
    gridArea: '3 / 5 / auto / span 2',
    refer2: [10, 13],
}, {
    class: 'board__bets__hiden-v itemV24',
    gridArea: '3 / 6 / auto / span 2',
    refer2: [13, 16],
    represent: 'Tiers',
}, {
    class: 'board__bets__hiden-v itemV25',
    gridArea: '3 / 7 / auto / span 2',
    refer2: [16, 19],
}, {
    class: 'board__bets__hiden-v itemV26',
    gridArea: '3 / 8 / auto / span 2',
    refer2: [19, 22],
    represent: 'Voisins',
}, {
    class: 'board__bets__hiden-v itemV27',
    gridArea: '3 / 9 / auto / span 2',
    refer2: [22, 25],
}, {
    class: 'board__bets__hiden-v itemV28',
    gridArea: '3 / 10 / auto / span 2',
    refer2: [25, 28],
}, {
    class: 'board__bets__hiden-v itemV29',
    gridArea: '3 / 11 / auto / span 2',
    refer2: [28, 31],
}, {
    class: 'board__bets__hiden-v itemV210',
    gridArea: '3 / 12 / auto / span 2',
    refer2: [31, 34],
    represent: 'Orphelins',
},
// -------- ↑ 竖向部分 -------------------------
// -------- ↓ One on four -------------------------
{
    mark: '■■■ On four ■■■',
    class: 'board__bets__hiden-v-h itemVH00',
    gridArea: '1 / 2 / span 2 / span 2',
    refer2: [...aColumn[0].slice(0, 2), ...aColumn[1].slice(0, 2)],
}, {
    class: 'board__bets__hiden-v-h itemVH01',
    gridArea: '1 / 3 / span 2 / span 2',
    refer2: [...aColumn[1].slice(0, 2), ...aColumn[2].slice(0, 2)],
}, {
    class: 'board__bets__hiden-v-h itemVH02',
    gridArea: '1 / 4 / span 2 / span 2',
    refer2: [...aColumn[2].slice(0, 2), ...aColumn[3].slice(0, 2)],
}, {
    class: 'board__bets__hiden-v-h itemVH03',
    gridArea: '1 / 5 / span 2 / span 2',
    refer2: [...aColumn[3].slice(0, 2), ...aColumn[4].slice(0, 2)],
}, {
    class: 'board__bets__hiden-v-h itemVH04',
    gridArea: '1 / 6 / span 2 / span 2',
    refer2: [...aColumn[4].slice(0, 2), ...aColumn[5].slice(0, 2)],
}, {
    class: 'board__bets__hiden-v-h itemVH05',
    gridArea: '1 / 7 / span 2 / span 2',
    refer2: [...aColumn[5].slice(0, 2), ...aColumn[6].slice(0, 2)],
}, {
    class: 'board__bets__hiden-v-h itemVH06',
    gridArea: '1 / 8 / span 2 / span 2',
    refer2: [...aColumn[6].slice(0, 2), ...aColumn[7].slice(0, 2)],
}, {
    class: 'board__bets__hiden-v-h itemVH07',
    gridArea: '1 / 9 / span 2 / span 2',
    refer2: [...aColumn[7].slice(0, 2), ...aColumn[8].slice(0, 2)],
}, {
    class: 'board__bets__hiden-v-h itemVH08',
    gridArea: '1 / 10 / span 2 / span 2',
    refer2: [...aColumn[8].slice(0, 2), ...aColumn[9].slice(0, 2)],
}, {
    class: 'board__bets__hiden-v-h itemVH09',
    gridArea: '1 / 11 / span 2 / span 2',
    refer2: [...aColumn[9].slice(0, 2), ...aColumn[10].slice(0, 2)],
}, {
    class: 'board__bets__hiden-v-h itemVH010',
    gridArea: '1 / 12 / span 2 / span 2',
    refer2: [...aColumn[10].slice(0, 2), ...aColumn[11].slice(0, 2)],
},
// ====================================================
{
    class: 'board__bets__hiden-v-h itemVH10',
    gridArea: '2 / 2 / span 2 / span 2',
    refer2: [...aColumn[0].slice(1), ...aColumn[1].slice(1)],
}, {
    class: 'board__bets__hiden-v-h itemVH11',
    gridArea: '2 / 3 / span 2 / span 2',
    refer2: [...aColumn[1].slice(1), ...aColumn[2].slice(1)],
}, {
    class: 'board__bets__hiden-v-h itemVH12',
    gridArea: '2 / 4 / span 2 / span 2',
    refer2: [...aColumn[2].slice(1), ...aColumn[3].slice(1)],
}, {
    class: 'board__bets__hiden-v-h itemVH13',
    gridArea: '2 / 5 / span 2 / span 2',
    refer2: [...aColumn[3].slice(1), ...aColumn[4].slice(1)],
}, {
    class: 'board__bets__hiden-v-h itemVH14',
    gridArea: '2 / 6 / span 2 / span 2',
    refer2: [...aColumn[4].slice(1), ...aColumn[5].slice(1)],
}, {
    class: 'board__bets__hiden-v-h itemVH15',
    gridArea: '2 / 7 / span 2 / span 2',
    refer2: [...aColumn[5].slice(1), ...aColumn[6].slice(1)],
}, {
    class: 'board__bets__hiden-v-h itemVH16',
    gridArea: '2 / 8 / span 2 / span 2',
    refer2: [...aColumn[6].slice(1), ...aColumn[7].slice(1)],
}, {
    class: 'board__bets__hiden-v-h itemVH17',
    gridArea: '2 / 9 / span 2 / span 2',
    refer2: [...aColumn[7].slice(1), ...aColumn[8].slice(1)],
}, {
    class: 'board__bets__hiden-v-h itemVH18',
    gridArea: '2 / 10 / span 2 / span 2',
    refer2: [...aColumn[8].slice(1), ...aColumn[9].slice(1)],
    represent: 'Voisins',
}, {
    class: 'board__bets__hiden-v-h itemVH19',
    gridArea: '2 / 11 / span 2 / span 2',
    refer2: [...aColumn[9].slice(1), ...aColumn[10].slice(1)],
}, {
    class: 'board__bets__hiden-v-h itemVH110',
    gridArea: '2 / 12 / span 2 / span 2',
    refer2: [...aColumn[10].slice(1), ...aColumn[11].slice(1)],
},
// ------------ ↑ one on four --------------------------------
// ------------ ↓ 特殊项 --------------------------------------
{
    mark: '■■■ special ■■■',
    class: 'board__bets__hiden-v itemD0',
    gridArea: '1 / 1 / auto / span 2',
    refer2: [0, 3],
    represent: 'Jeu Zero',
}, {
    class: 'board__bets__hiden-v itemD1',
    gridArea: '2 / 1 / auto / span 2',
    refer2: [0, 2],
}, {
    class: 'board__bets__hiden-v itemD2',
    gridArea: '3 / 1 / auto / span 2',
    refer2: [0, 1],
}, {
    class: 'board__bets__hiden-v-h itemDop0',
    gridArea: '1 / 1 / span 2 / span 2',
    refer2: [0, 2, 3],
    represent: 'Voisins',
}, {
    class: 'board__bets__hiden-v-h itemDop1',
    gridArea: '2 / 1 / span 2 / span 2',
    refer2: [0, 1, 2],
},].map((cur: ButtonIF) => {
    cur.hidden = true;
    return cur;
});


// ↓组合
export const aOptionList: ButtonIF[] = [
    ...aButtonInShow, // board__bets__item
    ...aButtonHidden, // board__bets__hiden
].map(cur => {
    let class02 = (
        cur.hidden
        ? 'board__bets__hiden'
        : 'board__bets__item'
    );
    cur.class = (cur.class + ' ' + class02);
    cur.placed = 0;
    // ↓ 生成标记，用于显示游戏历史 
    cur.sValueSign = (()=>{
        if (cur.areaName) {
            return cur.areaName; // 一定放在第1行
        }else if (cur?.refer2?.length) {
            const arr = [...cur.refer2].sort((aa, bb) => {
                return aa - bb;
            });
            return arr.join(',');
        }else if (cur.value >= 0) {
            return String(cur.value);
        }
    })();
    const [sRowIndex] = cur.gridArea;
    const sRest = cur.gridArea.slice(1);
    // ↓ 改版之后新增变更 
    cur.gridArea = (()=>{
        if (cur.value === 0) return cur.gridArea;
        // ↓ 应对最边缘那一行（移动端为列）不可见元素的定位 
        if (cur.class.match(/board__bets__hiden-t(-d)?/)){
            if (sRowIndex == '1') return `5${sRest}`;
        }
        if (sRowIndex == '1') return `3${sRest}`;
        if (sRowIndex == '2') return `4${sRest}`;
        if (sRowIndex == '3') return `5${sRest}`;
        if (sRowIndex == '4') return `2${sRest}`;
        if (sRowIndex == '5') return `1${sRest}`;
        return cur.gridArea;
    })();
    return cur;
});


const aJeuZero = [12, 35, 3, 26, 0, 32, 15]; // 环零区
const aVoisins = [22, 18, 29, 7, 28, ...aJeuZero, 19, 4, 21, 2, 25]; // 顶部
const aTiers = [27, 13, 36, 11, 30, 8, 23, 10, 5, 24, 16, 33]; // 底部
const aOrphelins = oneTo36.filter(cur => { // 左右分散
    const judgement01 = !aVoisins.includes(cur);
    const judgement02 = !aTiers.includes(cur);
    return judgement01 && judgement02;
});

export const aLeftBtn = [{
    label: 'Voisins', // 用了 i18nKey 之后，label 疑似废弃了 
    i18nKey: 'roulette.Voisins',
    refer2: aVoisins,
    gridArea: '1 / 2 / auto / span 3',
}, {
    label: 'Orphelins',
    i18nKey: 'roulette.Orphelins',
    refer2: aOrphelins,
    gridArea: '1 / span 3',
}, {
    label: 'Tiers',
    i18nKey: 'roulette.Tiers',
    refer2: aTiers,
    gridArea: '1 / span 3',
}, {
    label: 'Jeu Zero', // 原版改为了 Zero （仅在移动端显现为 zero
    i18nKey: 'roulette.Zero',
    refer2: aJeuZero,
    gridArea: '1 / span 3',
},];


// ↓ 用于 svg 的扇形区域
export const aPath = [
    { no: 0, dValue: 'M154.06 18.6282L142.507 142.392L132.622 18.2666L154.06 18.6282Z' },
    { no: 1, dValue: 'M48.4981 223.718L142.504 142.39L62.9538 238.11L48.4981 223.718Z' },
    { no: 2, dValue: 'M254.247 87.6185L142.507 142.393L243.104 69.6283C247.718 76.2009 250.164 80.1411 254.247 87.6185Z' },
    { no: 3, dValue: 'M112.378 21.7979L142.506 142.393L92.1285 28.6433L112.378 21.7979Z' },
    { no: 4, dValue: 'M213.247 40.5238L142.506 142.392L229.183 53.6597C223.182 47.8271 219.708 44.9485 213.247 40.5238Z' },
    { no: 5, dValue: 'M119.462 264.296L142.507 142.392L140.822 266.615C132.301 266.203 127.586 265.797 119.462 264.296Z' },
    { no: 6, dValue: 'M263.331 170.696L142.507 142.393L266.703 149.341C265.879 157.936 265.253 162.668 263.331 170.696Z' },
    { no: 7, dValue: 'M42.9735 67.8729L142.506 142.392L31.9326 85.9254L42.9735 67.8729Z' },
    { no: 8, dValue: 'M201.013 251.867L142.507 142.392L182.02 260.193C189.711 257.399 193.895 255.594 201.013 251.867Z' },
    { no: 9, dValue: 'M20.9872 167.99L142.506 142.393L18.2508 147.025C18.7117 155.31 19.5336 159.854 20.9872 167.99Z' },
    { no: 10, dValue: 'M140.822 266.616L142.507 142.392L161.674 265.248C153.317 266.305 148.726 266.661 140.822 266.616Z' },
    // ----------------
    { no: 11, dValue: 'M234.52 225.611L142.507 142.392L218.969 240.377C225.374 235.101 228.823 231.599 234.52 225.611Z' },
    { no: 12, dValue: 'M73.5471 38.8659L142.506 142.392L57.1342 51.7459L73.5471 38.8659Z' },
    { no: 13, dValue: 'M247.48 209.139L142.507 142.392L257.525 190.197L247.48 209.139Z' },
    { no: 14, dValue: 'M26.887 187.918L142.507 142.392L36.0573 206.494C32.0096 199.439 30.0101 195.368 26.887 187.918Z' },
    { no: 15, dValue: 'M174.807 22.2202L142.507 142.392L194.851 29.4329C187.258 26.086 182.718 24.6147 174.807 22.2202Z' },
    { no: 16, dValue: 'M80.6856 250.097L142.506 142.393L99.8014 259.038C92.1034 256.046 87.9048 254.117 80.6856 250.097Z' },
    { no: 17, dValue: 'M266.18 128.071L142.507 142.392L261.924 107.736L266.18 128.071Z' },
    { no: 18, dValue: 'M19.2025 125.552L142.507 142.392L23.9379 105.362L19.2025 125.552Z' },
    { no: 19, dValue: 'M194.851 29.433L142.507 142.392L213.247 40.524C206.143 35.9734 202.387 33.1409 194.851 29.433Z' },
    { no: 20, dValue: 'M36.0573 206.494L142.507 142.392L48.4982 223.718C43.3109 217.512 40.5599 213.791 36.0573 206.494Z' },
    // ----------------
    { no: 21, dValue: 'M142.506 142.392L243.104 69.6281C238.099 62.9644 235.083 59.437 229.183 53.6598L142.506 142.392Z' },
    { no: 22, dValue: 'M18.2511 147.025L142.506 142.393L19.2025 125.552C18.3689 133.948 18.1381 138.627 18.2511 147.025Z' },
    { no: 23, dValue: 'M142.505 142.393L161.674 265.248L182.019 260.192L142.505 142.393Z' },
    { no: 24, dValue: 'M99.8013 259.037L142.507 142.393L119.462 264.296C111.7 262.761 107.395 261.611 99.8013 259.037Z' },
    { no: 25, dValue: 'M261.923 107.736L142.507 142.392L254.247 87.6184L261.923 107.736Z' },
    { no: 26, dValue: 'M132.622 18.2668L142.507 142.393L112.378 21.7975L132.622 18.2668Z' },
    { no: 27, dValue: 'M257.441 190.143L142.506 142.392L263.331 170.696L257.441 190.143Z' },
    { no: 28, dValue: 'M57.1343 51.7457L142.506 142.392L42.9734 67.8734L57.1343 51.7457Z' },
    { no: 29, dValue: 'M142.507 142.393L31.9326 85.926C28.3953 93.3249 26.6641 97.5845 23.9376 105.362L142.507 142.393Z' },
    { no: 30, dValue: 'M218.969 240.377L142.507 142.392L201.013 251.867C208.273 247.569 212.268 245.439 218.969 240.377Z' },
    // ----------------
    { no: 31, dValue: 'M20.9873 167.989L142.507 142.392L26.887 187.918C24.3133 180.252 22.9664 175.913 20.9873 167.989Z' },
    { no: 32, dValue: 'M174.807 22.2201L142.507 142.392L154.06 18.6283L174.807 22.2201Z' },
    { no: 33, dValue: 'M62.9539 238.11L142.507 142.393L80.6854 250.097C73.6024 246.078 69.7404 243.377 62.9539 238.11Z' },
    { no: 34, dValue: 'M266.703 149.341L142.506 142.392L266.179 128.071L266.703 149.341Z' },
    { no: 35, dValue: 'M92.1294 28.6432L142.507 142.392L73.5478 38.8662L92.1294 28.6432Z' },
    { no: 36, dValue: 'M234.52 225.611L142.507 142.392L247.48 209.139C242.693 215.922 239.88 219.57 234.52 225.611Z' },
];



// ↓ 赔付表（在原站点上 name 值没有对应的译文 
export const aPayouts = [{
    i18n: 'bet_Straight',
    desc: 'desc_Straight', // i18n 键名 
    value: '', // '35:1', 此值后期通过查询取得 
    match: '1',
}, {
    i18n: 'bet_Split',
    desc: 'desc_Split',
    value: '', // '17:1',
    match: '2',
}, {
    i18n: 'bet_Street',
    desc: 'desc_Street',
    value: '', // '11:1',
    match: '3',
}, {
    i18n: 'bet_Corner',
    desc: 'desc_Corner',
    value: '', // '8:1',
    match: '4',
}, {
    i18n: 'bet_SixLine',
    desc: 'desc_SixLine',
    value: '', // '5:1',
    match: '6',
}, 
// ---  ↓ 2:1(x3) ------------------------------------------
{
    i18n: 'bet_ColumnBet',
    desc: 'desc_ColumnBet',
    value: '',
    match: '1-12',
}, {
    i18n: 'bet_firstDozen',
    desc: 'desc_firstDozen',
    value: '',
    match: '1-12',
}, {
    i18n: 'bet_secondDozen',
    desc: 'desc_secondDozen',
    value: '',
    match: '13-24',
}, {
    i18n: 'bet_thirdDozen',
    desc: 'desc_thirdDozen',
    value: '',
    match: '25-36',
}, 
// ---  ↓ 1:1(x2) ------------------------------------------
{
    i18n: 'bet_RedBlackNumbers',
    desc: 'desc_RedBlackNumbers',
    value: '',
    match: 'red',
}, {
    i18n: 'bet_OddEvenNumbers',
    desc: 'desc_OddEvenNumbers',
    value: '',
    match: 'odd',
}, {
    i18n: 'bet_LowHigh',
    desc: 'desc_LowHigh',
    value: '',
    match: '1to18',
}];


// ↓ 下方的键名与后端返回值对应，不可轻易变更 
export const kk = Object.freeze({
    chips: [{
        name: "1",
        value: 1
    }, {
        name: "10",
        value: 10
    }, {
        name: "100",
        value: 100
    }, {
        name: "1k",
        value: 1e3
    }, {
        name: "10k",
        value: 1e4
    }, {
        name: "100k",
        value: 1e5
    }, {
        name: "1m",
        value: 1e6
    }],
    "2-1": [[3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36], [2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35], [1, 4, 7, 10, 13, 16, 19, 22, 25, 28, 31, 34]],
    "1-12": [3, 6, 9, 12, 2, 5, 8, 11, 1, 4, 7, 10],
    "13-24": [15, 18, 21, 24, 14, 17, 20, 23, 13, 16, 19, 22],
    "25-36": [27, 30, 33, 36, 26, 29, 32, 35, 25, 28, 31, 34],
    "1to18": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
    "19to36": [19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36],
    even: [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36],
    odd: [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23, 25, 27, 29, 31, 33, 35],
    red: [3, 9, 12, 18, 21, 27, 30, 36, 5, 14, 23, 32, 1, 7, 16, 19, 25, 34],
    black: [6, 15, 24, 33, 2, 8, 11, 17, 20, 26, 29, 35, 4, 10, 13, 22, 28, 31],
    items_v: [[[3, 6], [6, 9], [9, 12], [12, 15], [15, 18], [18, 21], [21, 24], [24, 27], [27, 30], [30, 33], [33, 36]], [[2, 5], [5, 8], [8, 11], [11, 14], [14, 17], [17, 20], [20, 23], [23, 26], [26, 29], [29, 32], [32, 35]], [[1, 4], [4, 7], [7, 10], [10, 13], [13, 16], [16, 19], [19, 22], [22, 25], [25, 28], [28, 31], [31, 34]]],
    items_h: [[[3, 2], [6, 5], [9, 8], [12, 11], [15, 14], [18, 17], [21, 20], [24, 23], [27, 26], [30, 29], [33, 32], [36, 35]], [[2, 1], [5, 4], [8, 7], [11, 10], [14, 13], [17, 16], [20, 19], [23, 22], [26, 25], [29, 28], [32, 31], [35, 34]]],
    items_t: [[3, 2, 1], [6, 5, 4], [9, 8, 7], [12, 11, 10], [15, 14, 13], [18, 17, 16], [21, 20, 19], [24, 23, 22], [27, 26, 25], [30, 29, 28], [33, 32, 31], [36, 35, 34]],
    items_vh: [[[3, 6, 2, 5], [6, 9, 5, 8], [9, 12, 8, 11], [12, 15, 11, 14], [15, 18, 14, 17], [18, 21, 17, 20], [21, 20, 24, 23], [24, 23, 27, 26], [27, 26, 30, 29], [30, 29, 33, 32], [33, 32, 36, 35]], [[2, 5, 1, 4], [5, 4, 8, 7], [8, 7, 11, 10], [11, 10, 14, 13], [14, 13, 17, 16], [17, 16, 20, 19], [20, 19, 23, 22], [23, 22, 26, 25], [26, 25, 29, 28], [29, 28, 32, 31], [32, 31, 35, 34]]],
    items_td: [[0, 1, 2, 3], [3, 2, 1, 6, 5, 4], [6, 5, 4, 9, 8, 7], [9, 8, 7, 12, 11, 10], [12, 11, 10, 15, 14, 13], [15, 14, 13, 18, 17, 16], [18, 17, 16, 21, 20, 19], [21, 20, 19, 24, 23, 22], [24, 23, 22, 27, 26, 25], [27, 26, 25, 30, 29, 28], [30, 29, 28, 33, 32, 31], [33, 32, 31, 36, 35, 34]],
    items_dop: [[0, 3], [0, 2], [0, 1]],
    items_dop2: [[0, 3, 2], [0, 2, 1]],
});



export const oBetPattern = (()=>{
    const oResult = {
        // '2': [],
        // '3': [],
        // .........
    }
    const getArr = (arr)=>{
        if (!Array.isArray(arr)) return;
        if (Array.isArray(arr[0])){
            arr.forEach(cur => {
                getArr(cur)
            });
        }else if (typeof arr[0] === 'number'){
            const sLen = String(arr.length);
            oResult[sLen] ||= [];
            oResult[sLen].push(arr);
        }
    };
    Object.values(kk).forEach(cur=>{
        getArr(cur);
    });
    return oResult;
})();

// console.log('oBetPattern\n', oBetPattern);






